/* eslint-disable prettier/prettier */
// @flow
import React from 'react'
import styled from 'styled-components'
import * as THREE from 'three'
import OrbitControls from 'three-orbitcontrols'
import GLTFLoader from 'three-gltf-loader'

// Styling
import { colors } from '../../styles/styleGuide'
import { mqFrom } from '../../styles/mediaQueries'

// Models
// $FlowFixMe
import animation from '../../constants/jungleo.glb'
// $FlowFixMe
import enter from '../../constants/enter.glb'
// $FlowFixMe
import painting from '../../constants/painting.glb'
// $FlowFixMe
import lovestories from '../../constants/lovestories.glb'
// $FlowFixMe
import presentAnimation from '../../constants/present.glb'
// $FlowFixMe
import texas from '../../constants/swsx.glb'
// $FlowFixMe
import jmlogo from '../../constants/jmlogo.glb'
// $FlowFixMe
import mp3 from '../../constants/JungleBell.mp3'
import {
  Ajax,
  AkzoNobel,
  Bam,
  Bready,
  BasicFit,
  Polaroid,
  AirPlane,
  Star,
  Tree,
  bell,
  snow,
  FireWorks,
  fireworks,
  Globe,
  BigTree,
  Image,
  Palm,
  Snowman
} from '../../constants/three'

// eslint-disable-next-line one-var
let scene,
  camera,
  HEIGHT,
  WIDTH,
  renderer,
  sphereTab = [],
  globe,
  world,
  football,
  star,
  hemisphereLight,
  shadowLight,
  palm,
  writing,
  tree,
  sound,
  audioListener,
  audioLoader,
  controls
let lightness = 60

const loader = new GLTFLoader()

type State = {
  showWish: boolean,
  insideGlobe: boolean,
  click: boolean
}

class Home extends React.Component<*, State> {
  state = {
    showWish: false,
    insideGlobe: false,
    click: false
  }

  handleWindowResize = () => {
    HEIGHT = window.innerHeight
    WIDTH = window.innerWidth
    renderer.setSize(WIDTH, HEIGHT)
    camera.aspect = WIDTH / HEIGHT
    camera.updateProjectionMatrix()
  }

  createScene = () => {
    HEIGHT = window.innerHeight
    WIDTH = window.innerWidth

    scene = new THREE.Scene()
    scene.fog = new THREE.Fog(0xf4f4f4, 100, 950)

    camera = new THREE.PerspectiveCamera(60, WIDTH / HEIGHT, 1, 1000)

    camera.position.x = 0
    camera.position.z = 600
    camera.position.y = 70
    camera.lookAt(new THREE.Vector3(0, 15, 0))

    renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true })
    renderer.setSize(WIDTH, HEIGHT)
    renderer.sortObjects = false
    renderer.shadowMap.enabled = true

    const container = document.getElementById('world')
    // $FlowFixMe
    container.appendChild(renderer.domElement)

    window.addEventListener('resize', this.handleWindowResize, false)

    audioListener = new THREE.AudioListener()
    camera.add(audioListener)
    sound = new THREE.Audio(audioListener)
    audioLoader = new THREE.AudioLoader()
    audioLoader.load(mp3, buffer => {
        sound.setBuffer(buffer)
        sound.setVolume(0.5)
      }
    )

    star = new Star()
    star.mesh.position.set(0, 30, 0)
    scene.add(star.mesh)

    star.mesh.add(sound)

    for (let i = 0; i < 40; i++) {
      const lumiereS = new THREE.MeshPhongMaterial({
        emissive: '#7fe3ff'
      })
      sphereTab.push(
        new THREE.Mesh(
          new THREE.SphereGeometry(Math.random() * 1, 20, 20),
          lumiereS
        )
      )
    }
    for (let i = 0; i < sphereTab.length; i++) {
      sphereTab[i].position.set(
        Math.random() * 600 - 300,
        Math.random() * 600 - 300,
        Math.random() * 600 - 300
      )
      scene.add(sphereTab[i])
    }
  }

  createLights = () => {
    hemisphereLight = new THREE.HemisphereLight(0xaaaaaa, 0x000000, 0.8)
    shadowLight = new THREE.DirectionalLight(0xffffff, 0.8)

    shadowLight.position.set(150, 350, 350)
    shadowLight.castShadow = true

    shadowLight.shadow.camera.left = -400
    shadowLight.shadow.camera.right = 400
    shadowLight.shadow.camera.top = 400
    shadowLight.shadow.camera.bottom = -400
    shadowLight.shadow.camera.near = 1
    shadowLight.shadow.camera.far = 1000

    shadowLight.shadow.mapSize.width = 2048
    shadowLight.shadow.mapSize.height = 2048

    scene.add(hemisphereLight)
    scene.add(shadowLight)
  }

  createWorld = () => {
    const World = function() {
      const geo = new THREE.CylinderGeometry(310, 310, 500, 40, 10)
      geo.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI / 2))
      geo.applyMatrix(new THREE.Matrix4().makeRotationY(-Math.PI / 2))
      geo.mergeVertices()

      var l = geo.vertices.length

      this.waves = []

      for (let i = 0; i < l; i++) {
        let v = geo.vertices[i]
        this.waves.push({
          y: v.y,
          x: v.x,
          z: v.z,
          ang: Math.random() * Math.PI * 2,
          dis: 5 + Math.random() * 2,
          speed: 0.005 + Math.random() * 0.01
        })
      }
      let verts = geo.vertices
      let length = verts.length

      for (let i = 0; i < length; i++) {
        let v = verts[i]
        let vprops = this.waves[i]
        v.x = vprops.x + Math.cos(vprops.ang) * vprops.dis
        v.y = vprops.y + Math.sin(vprops.ang) * vprops.dis
        vprops.ang += vprops.speed
      }

      geo.verticesNeedUpdate = true
      const mat = new THREE.MeshPhongMaterial({
        color: 0xbca1c9,
        emissive: 0xf66120,
        specular: 0xffed22,
        shininess: 5,
        flatShading: true,
        transparent: 1,
        opacity: 1
      })
      this.mesh = new THREE.Mesh(geo, mat)
      this.mesh.receiveShadow = true
      this.mesh.castShadow = true

      let snowMen = []

      for (let i = 0; i < 3; i++) {
        snowMen.push(new Snowman())
        snowMen[i].mesh.scale.set(0.7, 0.7, 0.7)
        this.mesh.add(snowMen[i].mesh)
      }

      snowMen[0].mesh.position.set(-75, 184, -250)
      snowMen[0].mesh.rotation.set(
        THREE.Math.degToRad(-58),
        THREE.Math.degToRad(45),
        0
      )

      snowMen[1].mesh.position.set(85, 276, -145)
      snowMen[1].mesh.rotation.set(
        THREE.Math.degToRad(-47),
        THREE.Math.degToRad(-45),
        0
      )

      snowMen[2].mesh.position.set(-80, 257, 175)
      snowMen[2].mesh.rotation.set(
        THREE.Math.degToRad(20),
        THREE.Math.degToRad(40),
        0
      )

      const den = new Tree()
      den.mesh.scale.set(2.8, 2.8, 2.8)
      den.mesh.position.set(-60, 108, 295)
      den.mesh.rotation.set(THREE.Math.degToRad(50), 0, 0)
      this.mesh.add(den.mesh)

      const den1 = new Tree()
      den1.mesh.scale.set(2.4, 2.4, 2.4)
      den1.mesh.position.set(44, 60, 320)
      den1.mesh.rotation.set(THREE.Math.degToRad(50), 0, 0)
      this.mesh.add(den1.mesh)

      const den2 = new Tree()
      den2.mesh.scale.set(3, 3, 3)
      den2.mesh.position.set(90, 225, -210)
      den2.mesh.rotation.set(THREE.Math.degToRad(-40), 0, 0)
      this.mesh.add(den2.mesh)

      const den3 = new Tree()
      den3.mesh.scale.set(3, 3, 3)
      den3.mesh.position.set(80, 270, 150)
      den3.mesh.rotation.set(THREE.Math.degToRad(13), 0, 0)
      this.mesh.add(den3.mesh)

      const den4 = new Tree()
      den4.mesh.scale.set(3, 3, 3)
      den4.mesh.position.set(70, 302, -30)
      den4.mesh.rotation.set(THREE.Math.degToRad(-20), 0, 0)
      this.mesh.add(den4.mesh)

      const den5 = new Tree()
      den5.mesh.scale.set(2.5, 2.5, 2.5)
      den5.mesh.position.set(-80, 303, 50)
      den5.mesh.rotation.set(THREE.Math.degToRad(-3), 0, 0)
      this.mesh.add(den5.mesh)

      let forrest = []

      for (let i = 0; i < 6; i++) {
        forrest.push(new Tree())
        forrest[i].mesh.scale.set(2, 2, 2)
        forrest[i].mesh.rotation.set(THREE.Math.degToRad(-80), 0, 0)
        this.mesh.add(forrest[i].mesh)
      }

      forrest[0].mesh.position.set(-55, 64, -307)
      forrest[1].mesh.scale.set(1.7, 1.7, 1.7)
      forrest[1].mesh.position.set(50, 75, -301)
      forrest[2].mesh.position.set(-65, 105, -295)
      forrest[3].mesh.position.set(52, 141, -280)
      forrest[4].mesh.position.set(-70, 210, 205)
      forrest[5].mesh.position.set(-70, 297, -88)
      forrest[5].mesh.rotation.set(THREE.Math.degToRad(-35), 0, 0)

      // loader.load(santa, gltf => {
      //   const santa = gltf.scene
      //   santa.children[0].castShadow = true
      //   santa.children[0].receiveShadow = true
      //   santa.scale.set(3, 3, 3)
      //   santa.position.set(-31, 65, 300)
      //   santa.rotation.set(THREE.Math.degToRad(48), THREE.Math.degToRad(15), 0)
      //   this.mesh.add(santa)
      // })

      loader.load(presentAnimation, gltf => {
        const present = gltf.scene
        present.scale.set(3, 3, 3)
        present.position.set(48, 110, -286)
        present.children[6].material.color = new THREE.Color(0x004d34)
        present.children[6].castShadow = true
        present.children[7].castShadow = true
        present.children[7].material.color = new THREE.Color(0x004d34)
        present.rotation.set(THREE.Math.degToRad(-90), THREE.Math.degToRad(-10), 0)
        this.mesh.add(present)
      })

      loader.load(presentAnimation, gltf => {
        const present = gltf.scene
        present.scale.set(3, 3, 3)
        present.position.set(-50, 134, -277)
        present.children[6].material.color = new THREE.Color(0x004d34)
        present.children[6].castShadow = true
        present.children[7].castShadow = true
        present.children[7].material.color = new THREE.Color(0x004d34)
        present.rotation.set(THREE.Math.degToRad(-90), THREE.Math.degToRad(-10), 0)
        this.mesh.add(present)
      })

      // Jungle XL
      const junglexl = new Image('assets/junglexl.png')
      junglexl.mesh.scale.set(4.4, 2.6, 3)
      junglexl.mesh.position.set(-2, 113, 310)
      junglexl.mesh.rotation.set(
        THREE.Math.degToRad(37),
        0,
        0
      )
      this.mesh.add(junglexl.mesh)

      loader.load(jmlogo, gltf => {
        const logo = gltf.scene
        logo.children[2].material.color = new THREE.Color(0x03344a)
        logo.scale.set(230, 230, 230)
        logo.position.set(-4, 94, 299)
        logo.rotation.set(
          THREE.Math.degToRad(126),
          THREE.Math.degToRad(0),
          THREE.Math.degToRad(3)
        )
        this.mesh.add(logo)
      })

      // Vyoo
      loader.load(painting, gltf => {
        const vyoo = gltf.scene
        vyoo.scale.set(7, 7, 7)
        vyoo.position.set(-30, 144, 271)
        vyoo.rotation.set(THREE.Math.degToRad(34), THREE.Math.degToRad(-90), 0)
        const vyooPic = new Image('assets/vyoo1.png')
        vyooPic.mesh.scale.set(0.75, 0.55, 0.55)
        vyooPic.mesh.position.set(-27, 152, 276)
        vyooPic.mesh.rotation.set(THREE.Math.degToRad(35), 0, 0)
        this.mesh.add(vyoo, vyooPic.mesh)
      })

      const vyooPolaroid = new Image('assets/vyoo.png')
      vyooPolaroid.mesh.scale.set(4.5, 2.8, 3)
      vyooPolaroid.mesh.position.set(10, 170, 286)
      vyooPolaroid.mesh.rotation.set(
        THREE.Math.degToRad(29),
        THREE.Math.degToRad(-3),
        0
      )
      this.mesh.add(vyooPolaroid.mesh)

      // Bready
      const bready = new Image('assets/bready.png')
      bready.mesh.scale.set(4.5, 2.8, 3)
      bready.mesh.position.set(-4, 223, 248)
      bready.mesh.rotation.set(
        THREE.Math.degToRad(20),
        THREE.Math.degToRad(2),
        0
      )
      this.mesh.add(bready.mesh)

      const bread = new Bready()
      bread.mesh.position.set(26, 198.5, 238.5)
      bread.mesh.rotation.set(
        THREE.Math.degToRad(28),
        THREE.Math.degToRad(-15),
        0
      )
      this.mesh.add(bread.mesh)

      // Basic Fit
      const dumbbell = new BasicFit()
      dumbbell.mesh.scale.set(0.45, 0.45, 0.45)
      dumbbell.mesh.position.set(37, 239, 201)
      dumbbell.mesh.rotation.set(
        THREE.Math.degToRad(0),
        0,
        THREE.Math.degToRad(-180)
      )
      this.mesh.add(dumbbell.mesh)

      const basicfit = new Image('assets/basicfit.png')
      basicfit.mesh.scale.set(4.5, 2.7, 3)
      basicfit.mesh.position.set(2, 265, 202)
      basicfit.mesh.rotation.set(
        THREE.Math.degToRad(11),
        THREE.Math.degToRad(-1),
        0
      )
      this.mesh.add(basicfit.mesh)

      // BAM
      const house = new Bam()
      house.mesh.scale.set(0.75, 0.75, 0.75)
      house.mesh.position.set(-33, 272, 160.5)
      house.mesh.rotation.set(THREE.Math.degToRad(2), 0, 0)
      this.mesh.add(house.mesh)

      const bam = new Image('assets/bam.png')
      bam.mesh.scale.set(4.5, 2.6, 3)
      bam.mesh.position.set(-2, 300, 155)
      bam.mesh.rotation.set(0, THREE.Math.degToRad(2), 0)
      this.mesh.add(bam.mesh)

      // SXSW
      const sxsw = new Image('assets/sxsw.png')
      sxsw.mesh.scale.set(4.5, 2.6, 3)
      sxsw.mesh.position.set(1.5, 323, 104)
      sxsw.mesh.rotation.set(
        THREE.Math.degToRad(-9),
        THREE.Math.degToRad(-3),
        0
      )
      this.mesh.add(sxsw.mesh)

      loader.load(texas, gltf => {
        const sx = gltf.scene
        sx.scale.set(183, 183, 183)
        sx.position.set(26, 295, 112)
        sx.rotation.set(THREE.Math.degToRad(-18), THREE.Math.degToRad(-8), 0)
        this.mesh.add(sx)
      })

      // KLM
      const plane = new AirPlane()
      plane.mesh.scale.set(0.1, 0.1, 0.1)
      plane.mesh.position.set(-34, 332, 63)
      plane.mesh.rotation.set(THREE.Math.degToRad(-20), 0, 0)
      this.mesh.add(plane.mesh)

      const klm = new Image('assets/klm.png')
      klm.mesh.scale.set(4.5, 2.6, 3)
      klm.mesh.position.set(-1, 339, 50)
      klm.mesh.rotation.set(
        THREE.Math.degToRad(-18),
        THREE.Math.degToRad(1),
        0
      )
      this.mesh.add(klm.mesh)

      // Akzo Nobel
      const brush = new AkzoNobel()
      brush.mesh.scale.set(0.9, 0.9, 0.9)
      brush.mesh.position.set(30, 320, 7)
      brush.mesh.rotation.set(
        THREE.Math.degToRad(-30),
        THREE.Math.degToRad(-50),
        0
      )
      this.mesh.add(brush.mesh)

      const akzo = new Image('assets/akzo.png')
      akzo.mesh.scale.set(4.5, 2.6, 3)
      akzo.mesh.position.set(-1, 336, -4)
      akzo.mesh.rotation.set(
        THREE.Math.degToRad(-30),
        THREE.Math.degToRad(1),
        0
      )
      this.mesh.add(akzo.mesh)

      // Summer party
      const summerparty = new Image('assets/summerparty.png')
      summerparty.mesh.scale.set(4.5, 2.6, 3)
      summerparty.mesh.position.set(-3, 329, -60)
      summerparty.mesh.rotation.set(
        THREE.Math.degToRad(-40),
        THREE.Math.degToRad(4),
        0
      )
      this.mesh.add(summerparty.mesh)

      palm = new Palm()
      palm.mesh.scale.set(14, 14, 14)
      palm.mesh.position.set(-35, 311, -38)
      palm.mesh.rotation.set(THREE.Math.degToRad(-30), 0, 0)
      this.mesh.add(palm.mesh)

      // Ajax
      football = new Ajax()
      football.mesh.scale.set(0.02, 0.02, 0.02)
      football.mesh.position.set(-30, 304, -89)
      this.mesh.add(football.mesh)

      const ajax = new Image('assets/ajax.png')
      ajax.mesh.scale.set(4.5, 2.6, 3)
      ajax.mesh.position.set(4, 314, -108)
      ajax.mesh.rotation.set(
        THREE.Math.degToRad(-50),
        THREE.Math.degToRad(-3),
        0
      )
      this.mesh.add(ajax.mesh)

      // ECT
      const ect = new Image('assets/ect.png')
      ect.mesh.scale.set(4.5, 2.6, 3)
      ect.mesh.position.set(-3, 292, -160)
      ect.mesh.rotation.set(
        THREE.Math.degToRad(-60),
        THREE.Math.degToRad(3),
        0
      )
      this.mesh.add(ect.mesh)

      // Kroatie
      const kroatie = new Image('assets/kroatie.png')
      kroatie.mesh.scale.set(4.5, 2.6, 3)
      kroatie.mesh.position.set(-3, 252, -215)
      kroatie.mesh.rotation.set(THREE.Math.degToRad(-70), 0, 0)
      this.mesh.add(kroatie.mesh)

      palm = new Palm()
      palm.mesh.scale.set(12, 12, 12)
      palm.mesh.position.set(40, 246, -187)
      palm.mesh.rotation.set(THREE.Math.degToRad(-73), 0, 0)
      this.mesh.add(palm.mesh)

      // LoveStories
      loader.load(lovestories, gltf => {
        const ls = gltf.scene
        ls.scale.set(200, 200, 200)
        ls.position.set(-40, 208, -275)
        ls.rotation.set(THREE.Math.degToRad(0), 0, 0)
        this.mesh.add(ls)
      })

      const loves = new Image('assets/lovestories.png')
      loves.mesh.scale.set(4.5, 2.8, 3)
      loves.mesh.position.set(2, 199, -265)
      loves.mesh.rotation.set(THREE.Math.degToRad(-85), 0, 0)
      this.mesh.add(loves.mesh)
    }

    world = new World()
    world.mesh.position.z = -150
    world.mesh.position.y = -320
    world.mesh.position.x = 0
    world.mesh.rotation.x = -0.99
  }

  createLamps = () => {
    loader.load(animation, gltf => {
      writing = gltf.scene
      writing.scale.set(455, 455, 455)
      writing.position.set(-120, 170, 465)
      writing.rotation.set(THREE.Math.degToRad(90), 0, THREE.Math.degToRad(-7))
      scene.add(writing)
    })

    const polaroid = new Polaroid()
    polaroid.mesh.position.set(55, 35, 450)
    polaroid.mesh.rotation.set(THREE.Math.degToRad(-6), 0, 0)
    scene.add(polaroid.mesh)

    loader.load(enter, gltf => {
      const enter = gltf.scene
      enter.scale.set(414, 414, 414)
      enter.children[2].material.color = new THREE.Color(0x2b2b2b)
      enter.position.set(-114, 55, 460)
      enter.rotation.set(THREE.Math.degToRad(75), THREE.Math.degToRad(0.5), THREE.Math.degToRad(3))
      scene.add(enter)
    })
  }

  createTree = () => {
    tree = new BigTree()
    tree.mesh.scale.set(15, 15, 15)
    tree.mesh.position.y = -70
    scene.add(tree.mesh)
  }

  createGlobe = () => {
    globe = new Globe()
    globe.mesh.position.z = 0
    globe.mesh.position.y = -30
    globe.mesh.position.x = 0
    scene.add(globe.mesh)
  }

  changeScene = () => {
    const div = document.getElementById('world') || <div />
    if (camera.position.z < 56) {
      // $FlowFixMe
      div.style.opacity = 0
      scene.remove(globe.mesh)
      scene.remove(tree.mesh)
      scene.remove(writing)
      this.setState({ insideGlobe: true })
      star.mesh.scale.set(0.3, 0.3, 0.3)
      star.mesh.position.set(0, 40, 0)
      setTimeout(() => {
        for (let i = 0; i < 300; i++) {
          const lumiereS = new THREE.MeshPhongMaterial({
            emissive: '#7fe3ff'
          })
          sphereTab.push(
            new THREE.Mesh(
              new THREE.SphereGeometry(Math.random() * 1, 20, 20),
              lumiereS
            )
          )
        }
        for (let i = 0; i < sphereTab.length; i++) {
          sphereTab[i].position.set(
            Math.random() * 600 - 300,
            Math.random() * 600 - 300,
            Math.random() * 600 - 300
          )
          scene.add(sphereTab[i])
        }
        scene.add(world.mesh)
        // $FlowFixMe
        div.style.opacity = 1
      }, 0)
    } else {
      this.setState({ insideGlobe: false, showWish: false })
      scene.remove(world.mesh)
      scene.add(globe.mesh)
      scene.add(tree.mesh)
      scene.add(writing)
      controls.zoomSpeed = 0
    }
  }

  loop = () => {
    const timer = 0.00001 * Date.now()
    for (let i = 0; i < snow.length; i++) {
      const time = 0.0002 * Date.now()
      snow[i].position.x = 30 * Math.sin(time + i)
      snow[i].position.z = 30 * Math.sin(time + i * 1.1)
    }
    for (let i = 0; i < sphereTab.length; i++) {
      const sfere = sphereTab[i]
      sfere.position.x = 400 * Math.sin(timer + i)
      sfere.position.z = 400 * Math.sin(timer + i * 1.1)
    }
    for (let i = 0; i < bell.length; i++) {
      bell[i].mesh.rotation.y = 100 * Math.sin(timer + i)
    }

    if (writing) {
      lightness > 95 ? (lightness = 60) : lightness++
      writing.children[2].material.color = new THREE.Color(
        `hsl(45, 100%, ${lightness}%)`
      )
    }

    if (this.state.showWish) {
      if (THREE.Math.randInt(1, 20) === 10) {
        fireworks.push(new FireWorks(scene))
      }

      for (var i = 0; i < fireworks.length; i++) {
        if (fireworks[i].points !== null) {
          fireworks[i].points.scale.set(0.09, 0.09, 0.09)
          fireworks[i].points.position.set(50, -18, -120)
        }
        if (fireworks[i].done) {
          fireworks.splice(i, 1)
          continue
        }
        fireworks[i].update()
      }
    }

    if (this.state.click && camera.position.z > 55.5) {
      WIDTH < 800 ? camera.position.z -= 3 : camera.position.z -= 2
      camera.position.x = 0
      if (camera.position.y > 35) {
        camera.position.y -= 0.5
      }
      camera.updateProjectionMatrix()
      camera.lookAt(new THREE.Vector3(0, 15, 0))
      this.changeScene()
    } else if (this.state.click || camera.position.z < 55.5) {
      this.setState({ click: false })
      football.mesh.rotation.x += 1 / 70
      football.mesh.rotation.y += 1 / 120
      if (world.mesh.rotation.x <= 1.48) {
        WIDTH < 800 ? world.mesh.rotation.x += 0.0015 : world.mesh.rotation.x += 0.0008
      } else if (!this.state.showWish) {
        this.setState({ showWish: true })
      }
    }

    requestAnimationFrame(this.loop)
    renderer.render(scene, camera)
  }

  componentDidMount() {
    this.createScene()
    this.createLights()
    this.createGlobe()
    this.createTree()
    this.createWorld()
    this.createLamps()

    this.loop()

    controls = new OrbitControls(camera, renderer.domElement)
    controls.addEventListener('change', () => {
      this.changeScene()
    })
    controls.maxDistance = 600
    controls.minPolarAngle = (80 * Math.PI) / 180
    controls.maxPolarAngle = (80 * Math.PI) / 180
    controls.minAzimuthAngle = 0
    controls.maxAzimuthAngle = 0
  }

  handleClick = () => {
    this.setState({ click: true })
    sound.play()
    if (sound.context.state === 'suspended') {
      sound.context.resume()
    }
  }

  render() {
    const { insideGlobe, showWish } = this.state
    return (
      <World id="world" insideglobe={insideGlobe} onClick={this.handleClick}>
        <Wish id="wish" showwish={showWish}>
          <span>Jungle Minds wishes you</span><br />Happy Holidays!<br />
          <span><a href="https://www.jungleminds.com">jungleminds.com</a></span>
        </Wish>
      </World>
    )
  }
}

export default Home

const World = styled.div`
  position: absolute;
  width: 100%;
  transition: all 0.3s ease;
  background-color: ${colors.darkBlue};
`

const Wish = styled.h1`
  position: absolute;
  top: ${props => (props.showwish ? 40 : 35)}%;
  left: 50%;
  width: 100%;
  height: ${props => (props.showwish ? 60 : 90)}%;
  transform: translateX(-50%) translateY(-50%);
  transition: all 0.6s ease;
  color: ${colors.white};
  font-size: 55px;
  font-weight: 300;
  line-height: 55px;
  text-align: center;
  text-shadow: 0 0 5px #fff,
    0 0 10px #fff,
    0 0 15px #b3000c,
    0 0 20px #b3000c,
    0 0 25px #b3000c,
    0 0 30px #b3000c,
    0 0 35px #b3000c;
  opacity: ${props => (props.showwish ? 1 : 0)};

  > span {
    font-size: 21px;
    line-height: 21px;

    > a {
      display: ${props => props.showwish ? 'initial' : 'none'};
      color: black;
      text-decoration: none;
      text-shadow: 0 0;
    }
  }

  ${mqFrom.M`
    font-size: 105px;
    line-height: 105px;

    > span {
      font-size: 42px;
      line-height: 42px;
    }
  `};

  ${mqFrom.L`
    font-size: 160px;
    line-height: 160px;

    > span {
      font-size: 64px;
      line-height: 64px;
    }
  `};
`



// WEBPACK FOOTER //
// ./src/components/pageTypes/Home.js